import { useTranslation } from 'react-i18next';
import { TbSettings } from 'react-icons/tb';
import { Link, useLocation } from 'react-router';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@cccom/ui/src/components/shadcn/tooltip';
import { cn } from '@cccom/ui/src/utils';

export function Settings({ isCollapsed }: { isCollapsed: boolean }) {
  const [t] = useTranslation();
  const { pathname } = useLocation();
  const isActive = pathname.startsWith('/settings');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link to="settings">
          <div
            className={cn(
              'flex w-full items-center gap-4 px-7 py-4 text-gray-500 transition-colors',
              isActive ? 'bg-gray-100' : 'bg-transparent',
              'hover:bg-gray-100',
              isCollapsed ? 'justify-center' : 'justify-start'
            )}
          >
            <div className="flex items-center gap-4">
              <TbSettings className="text-2xl" />
              <span
                className={cn(
                  'transition-opacity',
                  isCollapsed ? 'absolute opacity-0' : 'relative opacity-100'
                )}
              >
                {t('atreview.settings.title')}
              </span>
            </div>
          </div>
        </Link>
      </TooltipTrigger>
      <TooltipContent side="right" className="text-xs">
        {t('atreview.settings.title')}
      </TooltipContent>
    </Tooltip>
  );
}
